var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"parallax-container",attrs:{"id":""}},[_c('div',{staticClass:"parallax",attrs:{"id":""}},[_c('img',{staticClass:"background",attrs:{"src":_vm.get_image_url(
                        'uploads/profile/public/slider-background.png',
                        'og'
                    )}}),_vm._v(" "),_c('h1',{staticClass:"title text-center"},[_vm._v("Discover My Audio")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }